import { render } from "./CloudLoginPage.vue?vue&type=template&id=397f80b3&scoped=true"
import script from "./CloudLoginPage.vue?vue&type=script&lang=js"
export * from "./CloudLoginPage.vue?vue&type=script&lang=js"

import "./CloudLoginPage.vue?vue&type=style&index=0&id=397f80b3&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-397f80b3"

export default script